import { render } from "./Scrapie.vue?vue&type=template&id=5fbb3ca0&scoped=true"
import script from "./Scrapie.vue?vue&type=script&lang=js"
export * from "./Scrapie.vue?vue&type=script&lang=js"

import "./Scrapie.vue?vue&type=style&index=0&id=5fbb3ca0&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbb3ca0"]])

export default __exports__